import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasDeleted.meta';

export type UseTrackCanvasDeletedParams = {
  canvas_id: string;
  board_id?: string;
  location?: 'board' | 'canvases';
};

export const useTrackCanvasDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasDeleted = useCallback(
    (params: UseTrackCanvasDeletedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasDeleted };
};
